import React from "react";

import investorimg3 from "../../img/investors/investorimg3.png";
import "./InvestorBottomSection.css";
import CTASecondary from "../../components/CTASecondary";
import { motion } from "framer-motion";

function InvestorBottomSection() {
  const fadeInUp = {
    hidden: { opacity: 1, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };
  return (
    <div className="InvestorBottomSection">
      <div className="InvestorBottomSection__top">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.01 }}
          variants={fadeInUp}
        >
          <div className="InvestorBottomSection__top__h1">
            <h1>Let's build something extraordinary together!</h1>
          </div>

          <div className="InvestorBottomSection__top__p">
            <p>
              Join us on this exciting journey and discover the benefits of
              investing in high-quality, luxury real estate. <br />
              Whether you're looking to build your dream villa or seeking
              profitable investment opportunities, Cabrera Fine Properties is
              your trusted local partner.
            </p>
          </div>
          <div className="InvestorBottomSection__top__button">
            <a href="/contact">
              <CTASecondary label="Contact us" />
            </a>
          </div>
        </motion.div>
      </div>
      <div className="InvestorBottomSection__bottom">
        <img
          src={investorimg3}
          alt="Luxury villa with sea view in Costa Blanca, Spain"
        />
      </div>
    </div>
  );
}

export default InvestorBottomSection;
